export const version = '@VERSION@';
